export default __webpack_public_path__ + "static/media/img-0190-ireland-half-face.91ddac69.png";